import { Model } from "pinia-orm";
import Role from "./Role";
import Company from "./Company";
import { Batch } from "./Batch";
import { COMPANY_ROLES } from "./enums/company-roles";
import CompanyProjectRole from "./CompanyProjectRole";
import ContributorBatch from "./ContributorBatch";
import Mission from "../Mission";

export default class Contributor extends Model {
  static name = "Contributor";
  static entity = "contributors";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
      projectId: this.uid(),
      project: this.hasOne(Mission, "uuid", "projectId"),
      userEmail: this.attr(""),
      userFirstName: this.attr(""),
      userLastName: this.attr(""),
      userPhoneNumber: this.attr(""),
      invitationByEmail: this.attr(""),
      invitationByUsermanagementUuid: this.attr(null),
      metadata: this.attr({}),
      roleId: this.attr(),
      roleAlias: this.attr(""),
      companyId: this.attr(null),
      companyRole: this.attr(COMPANY_ROLES.INCUMBENT_COMPANY),
      incumbentCompanyName: this.attr(""),
      role: this.belongsTo(Role, "roleId"),
      batches: this.belongsToMany(Batch, ContributorBatch, "contributorId", "batchId"),
      company: this.belongsTo(Company, "companyId"),
      arrivalDate: this.attr(""),
      plannedEndDate: this.attr(""),
      workDone: this.attr(""),
      projectedStaffing: this.attr(""),
      isMandatoryRecipient: this.boolean(false),
      isMainContact: this.boolean(false),
      isArchived: this.attr(false),
      isLocked: this.attr(false),
      usermanagementUuid: this.attr(null),
      synchronized: this.attr(true),
      hasApplicationAccess: this.boolean(false),
      companyProjectRoleId: this.attr(null),
      companyProjectRole: this.belongsTo(CompanyProjectRole, "companyProjectRoleId"),
    };
  }
}
